import Typography from '@components/v2/ui/Typography/Typography';
import { Column } from '../../../../components/ListV2/components/table/VirtualizedTable.types';
import LangEnum from '../../../../lang/LangEnum';
import { CatalogTestIds } from '../../../../utils/testIds/catalog.testIds';
import {
  CATALOG_CREATION_ACCESS_DATE_COLUMN_WIDTH,
  CATALOG_CREATION_ACCESS_ENTITY_COLUMN_WIDTH,
} from '../catalogCreationAccess.consts';
import {
  CatalogCreationAccessRow,
  CatalogCreationAccessRowDateChange,
} from '../catalogCreationAccess.types';
import CatalogCreationAccessDateCell from '../components/CatalogCreationAccessDateCell';

interface BuildCatalogCreationAccessColumnsParams {
  canEditDates: boolean;
  onChangeRowDate: (rowDateChange: CatalogCreationAccessRowDateChange) => void;
}

export const buildCatalogCreationAccessColumns = ({
  canEditDates,
  onChangeRowDate,
}: BuildCatalogCreationAccessColumnsParams): Column<CatalogCreationAccessRow>[] => [
  {
    name: 'name',
    title: LangEnum.GLOBAL_NAME,
    width: CATALOG_CREATION_ACCESS_ENTITY_COLUMN_WIDTH,
    canHide: false,
    render: (row) => ({
      node: (
        <Typography variant="body2" noWrap>
          {row.name}
        </Typography>
      ),
    }),
  },
  {
    name: 'startDate',
    title: LangEnum.GLOBAL_INITIAL_DATE,
    width: CATALOG_CREATION_ACCESS_DATE_COLUMN_WIDTH,
    canHide: false,
    render: (row) => ({
      node: (
        <CatalogCreationAccessDateCell
          value={row.startDate}
          isDisabled={!canEditDates}
          testId={`${CatalogTestIds.CATALOG_CREATION_MODAL_ACCESS_START_DATE_PREFIX}${row.id}`}
          onChange={(date) => onChangeRowDate({ entityId: row.id, dateField: 'startDate', date })}
        />
      ),
    }),
  },
  {
    name: 'endDate',
    title: LangEnum.GLOBAL_FINAL_DATE,
    width: CATALOG_CREATION_ACCESS_DATE_COLUMN_WIDTH,
    canHide: false,
    render: (row) => ({
      node: (
        <CatalogCreationAccessDateCell
          value={row.endDate}
          isDisabled={!canEditDates}
          testId={`${CatalogTestIds.CATALOG_CREATION_MODAL_ACCESS_END_DATE_PREFIX}${row.id}`}
          onChange={(date) => onChangeRowDate({ entityId: row.id, dateField: 'endDate', date })}
        />
      ),
    }),
  },
];
